module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ornament-prect"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ornament.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pVI"
    }
  }), _c('a', {
    attrs: {
      "id": "pVII"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/list_of_illustrations.htm#illus"
    }
  }, [_c('i', [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/list_of_principal_characters.htm#char"
    }
  }, [_c('i', [_vm._v("List of Principal Characters")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/preface.htm#preface"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_1.htm#ct1"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("  1 ")]), _vm._v("From Archduchess to Dauphine")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_2.htm#ct2"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("  2 ")]), _vm._v("The Court under Louis XVI and Marie-Antoinette")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_3.htm#ct3"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("  3 ")]), _vm._v("A Queen in Search of a Role, 1774–1781")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_4.htm#ct4"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("  4 ")]), _vm._v("Growing Unpopularity, 1781–1785")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_5.htm#ct5"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("  5 ")]), _vm._v("The Diamond Necklace Affair, 1785–1786")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_6.htm#ct6"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("  6 ")]), _vm._v("The Ascendancy of Marie-Antoinette, 1787–1788")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#ct7"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("  7 ")]), _vm._v("The Last Year at Versailles")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_8.htm#ct8"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("  8 ")]), _vm._v("Appeasement and Plans for Resistance: The Tuileries and Saint-Cloud")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_9.htm#ct9"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("  9 ")]), _vm._v("The Flight to Varennes")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_10.htm#ct10"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("10 ")]), _vm._v(" Marie-Antoinette will become Queen of France again’: Government by Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_11.htm#ct11"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("11 ")]), _vm._v("The Fall of the Monarchy")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_12.htm#ct12"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("12 ")]), _vm._v("Imprisonment in a Tower")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/conclusion.htm#conclusion"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/epilogue_ubi_sunt.htm#epilogue"
    }
  }, [_vm._v("Epilogue: "), _c('i', [_vm._v("Ubi sunt?")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect--"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#notes"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/a_bibliographical_essay.htm#essay"
    }
  }, [_c('i', [_vm._v("A Bibliographical Essay")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/bibliography.htm#biblio"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/index.htm#index"
    }
  }, [_c('i', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0